export const DURATION_UNITS = [
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
  { value: 'terms', label: 'Terms' },
];

export const PAYMENT_TERMS = [
  { value: 'full', label: 'One full installment' },
  { value: 'daily', label: 'Daily payments' },
  { value: 'weekly', label: 'Weekly payments' },
  { value: 'monthly', label: 'Monthly payments' },
  { value: 'per_term', label: 'Per term' },
];

export function formatCourseDuration(amount, unit) {
  if (!amount || !unit) return '';
  return `${amount} ${unit}`;
}

export function recommendedPaymentTerm(amount, unit) {
  const value = Number(amount || 0);
  if (unit === 'days' && value <= 14) return 'daily';
  if (unit === 'weeks') return 'weekly';
  if (unit === 'terms') return 'per_term';
  if (unit === 'months' || unit === 'years') return 'monthly';
  return value > 0 && value <= 14 ? 'daily' : 'full';
}

export function parseCourseDuration(duration, amount, unit) {
  if (amount && unit) return { amount: String(amount), unit };
  const match = String(duration || '').trim().match(/^(\d+(?:\.\d+)?)\s*(days?|weeks?|months?|years?|terms?)$/i);
  if (!match) return { amount: '', unit: 'weeks' };
  return { amount: match[1], unit: `${match[2].toLowerCase().replace(/s$/, '')}s` };
}
